/**
 * Per-app settings for the Channel Partner feature. This is the ONLY file in
 * features/channel-partner that differs between the customer and provider
 * apps — everything else is mirrored verbatim.
 */

/**
 * Customer signup link that pre-fills a CP code. The customer app hosts
 * signup on its own origin, and `/signup` reads `?ref=` into the referral
 * field (see routes/signup.tsx).
 */
export function channelPartnerSignupLink(code: string): string | null {
  if (typeof window === 'undefined') return null;
  return `${window.location.origin}/signup?ref=${encodeURIComponent(code)}`;
}
